import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Container, Paper } from "@material-ui/core";
import { Link } from "components/Typography/Typography";
import { pathName } from "pages/routes";

export const Main: React.FC = () => {
    const { t } = useTranslation();
    return (
        <Container>
            <Box m={4} p={4}>
                <Paper>
                    <Link p={2} to={pathName.SCHEDULER_OVERVIEW}>
                        {t("adminPanel.label.emailSchedulerOverview")}
                    </Link>
                    <Link p={2} to={pathName.TEMPLATES_OVERVIEW}>
                        {t("adminPanel.label.emailTemplatesOverview")}
                    </Link>
                    <Link p={2} to={pathName.CREATIVE_MAPPINGS_OVERVIEW}>
                        {t("adminPanel.label.creativeMappingsOverview")}
                    </Link>
                    <Link p={2} to={pathName.CAMPAIGN}>
                        {t("adminPanel.label.campaign")}
                    </Link>
                </Paper>
            </Box>
        </Container>
    );
};
